import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { Button } from "~views/shared";
import { Checkbox } from "~views/shared/Checkbox/Checkbox";
import { useStores } from "netbank-shared/src/hooks";
import offerStyles from "./Offers.scss";

interface IEmptyStateProps {
  consumeText: string;
  termsConditionText: string;
  cancelButtonText: string;
  isConsuming: boolean;
  checkBoxNotRequired: boolean;
  consumeOffer: () => void;
  cancelOffer: () => void;
}

export const OfferPageButtonSection = observer(
  ({
    consumeText,
    termsConditionText,
    isConsuming,
    checkBoxNotRequired,
    consumeOffer,
    cancelButtonText,
    cancelOffer,
  }: IEmptyStateProps) => {
    const [checked, setChecked] = useState(false);
    const { offerStore } = useStores();
    const trackingCategory = offerStore.getTrackingCategory();

    const hasTwoButtons = !!cancelButtonText;
    useEffect(() => {
      setChecked(checkBoxNotRequired);
    }, [checkBoxNotRequired]);
    return (
      <section>
        {!checkBoxNotRequired && (
          <Checkbox label={termsConditionText} checked={checked} onChange={(e) => setChecked(e.target.checked)} />
        )}
        <div className={offerStyles.submit}>
          {hasTwoButtons && (
            <Button type="secondary" onClick={cancelOffer} title={cancelButtonText} fullWidth={hasTwoButtons} />
          )}

          <Button
            disabled={!checked}
            fullWidth={hasTwoButtons}
            title={consumeText}
            onClick={() => consumeOffer()}
            loading={isConsuming}
            trackingCategory={trackingCategory}
            trackingAction={trackingCategory && offerStore.getTrackingCTA()}
            trackingPrefix={trackingCategory && offerStore.getTrackingEventPrefix()}
            trackingValue={trackingCategory && offerStore.getTrackingValue()}
          />
        </div>
      </section>
    );
  }
);
